import { RefObject, useEffect, useRef } from 'react'

import { GetConfiguredEntityParamsHandle } from '@pages/ConfiguredEntity'

import { ActualTimeWindowInterval } from '@hooks'

export const useRefreshObjectDataByTimeWindowChange = (
  configuredEntityRef: RefObject<GetConfiguredEntityParamsHandle>,
  actualTimeWindow: ActualTimeWindowInterval
) => {
  const activatedTimeWindow = useRef(false)

  useEffect(() => {
    if (!configuredEntityRef.current) {
      return
    }

    if (actualTimeWindow) {
      if (actualTimeWindow.isFirstIntervalRun) {
        activatedTimeWindow.current = false
      }

      // Таким образом мы игнорируем первый "тик", так-как при старте таймера уже сработал refresh данных благодаря ассистенту поиска
      if (!activatedTimeWindow.current) {
        activatedTimeWindow.current = true

        return
      }

      configuredEntityRef.current.refreshObjectData(undefined, undefined, actualTimeWindow)
    } else {
      activatedTimeWindow.current = false
    }
  }, [actualTimeWindow])
}
